import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n from "i18next";

const INSTANT_ALLOW = [
  "/instand_settings",
  "/instand_dashboard",
  "/dir_list",
  "/create_dir",
  "/dir_overview",
  "/contact",
  "/contactus",
];

const shouldUseLocal = (path) =>
  INSTANT_ALLOW.some((p) => path === p || path.startsWith(p));

export default function RouteLanguage() {
  const loc = useLocation();
  const raw = (loc?.pathname && loc.pathname !== "/" ? loc.pathname : window.location.hash.slice(1)) || "/";
  const path = raw.split("?")[0]; 

  useEffect(() => {
    const saved = localStorage.getItem("lang") || "en";
    if (shouldUseLocal(path)) {
      if (i18n.language !== saved) i18n.changeLanguage(saved);
    } else {
      if (i18n.language !== "en") i18n.changeLanguage("en");
    }
  }, [path]);

  return null;
}
